export enum AssetReturnPeriod {
  YTD = 'YTD',
  QTD = 'QTD',
  MTD = 'MTD',
}
